import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToasterConfig, ToasterContainerComponent, ToasterService } from 'angular2-toaster';
import { Globals } from 'app/globals/globals';
import { ConfigService } from 'app/services/config.service';
import { Level, Logger } from './shared/logger';
import { LoggerFactory } from './shared/loggerFactory';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    private logger: Logger;
    constructor(
        private toasterService: ToasterService,
        private config: ConfigService,
        private loggerFactory: LoggerFactory) {
        this.logger = this.loggerFactory.create('AppComponent');
    }

    public async ngOnInit() {
        let maxLoggingLevel = await this.config.get('maxLoggingLevel', Level.Warning);
        this.loggerFactory.setMaxLoggingLevel(maxLoggingLevel);
        this.logger.debug(`Maximum Logging Level is ${maxLoggingLevel}`);
    }

    public toasterconfig: ToasterConfig = new ToasterConfig({
        animation: 'fade',
        showCloseButton: true,
        tapToDismiss: true,
        timeout: 3000
    });
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts